import { MINERVA_API_URL, CLASSTING_OPEN_API_URL } from '@/config';
import { http } from '@/plugins/http';
import { omitBy } from 'lodash';

import * as types from './mutation-types';

export function fetchFilterAssignments({ dispatch }, filters) {
  return http.get(`${MINERVA_API_URL}/assignments`, { params: omitBy(filters, item => item === 'all') })
    .then(res => (
      dispatch('setFilterAssignments', {
        classId: filters.class_id || 0,
        status: filters.status,
        assignments: res.data,
      })
    ));
}

export function setFilterAssignments({ commit }, { classId, status, assignments }) {
  commit(types.SET_ASSIGNMENTS, { classId, status, assignments });

  return Promise.resolve(assignments);
}

export function fetchAssignmentStats({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/assignment-stats`)
    .then(res => (
      dispatch('setFilterAssignmentStats', {
        classId: 0,
        assignmentStats: res.data,
      })
    ));
}

export function fetchFilterAssignmentStats({ dispatch }, classId) {
  return http.get(`${MINERVA_API_URL}/assignment-stats?class_id=${classId}`)
    .then(res => (
      dispatch('setFilterAssignmentStats', {
        classId,
        assignmentStats: res.data,
      })
    ));
}

export function setFilterAssignmentStats({ commit }, { classId, assignmentStats }) {
  commit(types.SET_ASSIGNMENT_STATS, { classId, assignmentStats });

  return Promise.resolve(assignmentStats);
}

export function fetchClasses({ dispatch }, userId) {
  return http.get(`${CLASSTING_OPEN_API_URL}/users/${userId}/joined_classes`)
    .then(res => (
      dispatch('setClasses', res.data)
    ));
}

export function setClasses({ commit }, classes) {
  commit(types.SET_CLASSES, classes);

  return Promise.resolve(classes);
}

export function setClassId({ commit }, classId) {
  commit(types.SET_CLASS_ID, classId);
}

export function setAssignmentPosition({ commit }, { classId, assignmentPosition }) {
  commit(types.SET_ASSIGNMENT_POSITION, classId, assignmentPosition);
}

export function resetAssignments({ commit }) {
  commit(types.RESET_ASSIGNMENTS);
}



// WEBPACK FOOTER //
// ./src/app/cat-assignment/store/actions.js